import "./Brass.module.css";
import Header from "@/reusable_sections/Header";
import PageHeader from "./sections/PageHeader";
import DirectAnswerBlock from "./sections/DirectAnswerBlock";
import WhyBrassWhatItSFor from "./sections/WhyBrassWhatItSFor";
import BrassValveTagsFormats from "./sections/BrassValveTagsFormats";
import BrassPropertiesFinishes from "./sections/BrassPropertiesFinishes";
import WhenToChooseBrass from "./sections/WhenToChooseBrass";
import WhereBrassIsUsedProducts from "./sections/WhereBrassIsUsedProducts";
import FaqAccordion from "./sections/FaqAccordion";
import ClosingCta from "./sections/ClosingCta";
import Footer from "@/reusable_sections/Footer";
export default function BrassPage() {
  return <div>
      <Header />
      <PageHeader />
      <DirectAnswerBlock />
      <WhyBrassWhatItSFor />
      <BrassValveTagsFormats />
      <BrassPropertiesFinishes />
      <WhenToChooseBrass />
      <WhereBrassIsUsedProducts />
      <FaqAccordion />
      <ClosingCta />
      <Footer />
    </div>;
}